const API_URI = "http://propi.moohae.net:81/api/";

const IP_PORT = "http://propi.moohae.net:81";

const SERVICE_URI = "https://propi.moohae.net/";

module.exports = {API_URI, IP_PORT, SERVICE_URI}